<template>
  <div class="nomeados">
    <div class="row">
      <div class="col-xs-12">
        <button type="button" class="btn btn-primary btn-voltar" @click="$router.back()">
          <font-awesome-icon :icon="'arrow-left'"/>
          Voltar
        </button>
        <h2 class="page-header">Nomear Candidatos</h2>
        <h3>Edital nº {{ edital.numero }}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <data-table
          ref="vuetable"
          :title="'Lista de Cargos'"
          :dados="cargos"
          :fields="fields"
          :carregando="isLoading">
          <template slot="rowrender" slot-scope="props">
            <button
              class="btn btn-primary"
              @click="selecionarHabilitadosCargo(props.rowData)"
            >
              <font-awesome-icon :icon="'search'" />
              <span class="sr-only">Selecionar cargo</span>
            </button>
          </template>
        </data-table>
      </div>
    </div>
    <div class="row" v-if="cargo.id">

      <habilitado-table 
        id="lista-habilitados"
        title="Lista de Habilitados"
        :data="habilitadosGeral"
        :fullData="habilitados"
        @updateData="listarHabilitadosEdital"
      />

      <habilitado-table 
        title="Lista de Habilitados - PCD"
        :data="habilitadosPCD"
        :fullData="habilitados"
        @updateData="listarHabilitadosEdital"
      />

      <habilitado-table 
        title="Lista de Habilitados - Cotas"
        :is-cotas="true"
        :data="habilitadosCotas"
        :fullData="habilitados"
        @updateData="listarHabilitadosEdital"
      />

    </div>
  </div>
</template>

<script>
import { request } from '@/request'
import { scrollToElement } from '@/utils'
import DataTable from '@/components/common/NoApiTable'
import HabilitadoTable from '@/components/HabilitadoTable'

export default {
  components: { DataTable, HabilitadoTable },
  data() {
    return {
      cargo: {},
      cargos: [],
      edital: {
        id: 0,
        numero: null
      },
      habilitados: [],
      isLoading: false,
      fields: [
        {
          name: '__slot:input',
          title: '#',
          dataClass: 'text-center',
        },
        {
          name: 'descricao',
          title: 'Descrição',
        },
        {
          name: 'vagas',
          title: 'Vagas',
        },
        {
          name: 'vagas_pcd',
          title: 'Vagas PCD',
        },
        {
          name: 'vagas_cotas',
          title: 'Vagas Cotas',
        },
        {
          name: 'vagas_QP',
          title: 'Vagas QP',
        },
        {
          name: '__slot:actions',
          title: 'Visualizar',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    }
  },
  created() {
    this.edital = { ...this.$route.params.edital }

    if (_.isEmpty(this.edital)) {
      this.$router.push('/admin/concursos/edital')
    } else {
      this.listarCargosEdital()
      this.listarHabilitadosEdital()
    }
  },
  methods: {
    selecionarHabilitadosCargo(item) {
      this.cargo = item
      scrollToElement('lista-habilitados')
    },
    listarCargosEdital() {
      request
        .get('cargo', { params: { edital_id: this.edital.id } })
        .then((response) => {
          this.cargos = response.data
        })
        .catch((error) => {
          console.log(error.response)
        })
    },
    filter(key) {
      return (item) =>
        item[key] === 1 && item['descricao'] === this.cargo.descricao
    },
    listarHabilitadosEdital() {
      this.handleLoading()
      request
        .get('habilitado', { params: { edital_id: this.edital.id } })
        .then((response) => {
          this.habilitados = response.data
        })
        .catch((error) => console.log(error.response))
        .finally(this.handleLoading)
    },
    handleLoading() {
      this.isLoading = !this.isLoading
    }
  },
  computed: {
    habilitadosGeral() {
      return this.habilitados.filter(this.filter('tipo_normal'))
    },
    habilitadosPCD() {
      return this.habilitados.filter(this.filter('tipo_pcd'))
    },
    habilitadosCotas() {
      return this.habilitados.filter(this.filter('tipo_cotas'))
    }
  },
}
</script>

<style scoped>
.button-group {
  display: flex;
  align-items: center;
}
.button-group > * {
  margin-right: 5px;
}
.btn-voltar {
  margin-top: 20px;
}
tbody tr {
  height: 53px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/concursos/acompanhamento/Nomeados.vue